
/****************ELEMENTS*****************/
//this obj define, the actions realeted to each 
//th>table header and td

const dtUpdate = require('./item-dt-update')
const dtSearch = require('../../../../../components/dt/dt-search')
const dialogInventory = require('./item-dialog')
const inventorySnack = require('./item-snack')
const textfieldHandler = require('../../../../../components/textfield/textfield-handler')
const dialog = require('../../../../../components/dialog/dialog')

export const tableDetail = {
    entity: 'item',//name table on the db
    dest: 'item',//name of the entity on the system

    //action for body 
    //left click, directly to the fullcont 
    tdDataDetail: `data-detail='{ "click": [ {"dest":"ripple" },
                                            {"dest":"item", "elem":"fullcont", "id":"item-fullcont", "act":"selectOne", "entity":"item", "dbid": "#dbid"},
                                            {"dest":"item", "elem":"fullcont", "act":"obtenerDatosTablaItemBehaivor", "idItem":"#dbid" }  ],
                                
                                 "clickRight": [{"dest":"item", "elem":"dt", "act":"trMenu", "id":"trMenu",  "entity":"item", "dbid": "#dbid" } ]  }'`,

    filter: {
        mainFilterFields: ["item.name"],
        mainFilterValues: ["", ""],
        andFilterFields: [""],
        andFilterValues: [""],
    }

}

/****************ELEMENTS*****************/

// Definicion compartida para crear las filas y actualizar sus celdas.
export function getItemColumns(item) {
    return [
        {
            label: item.name,
            span: item.code,
            style: {
                tdClass: 'tdWithAvatar',
                avatar: item.avatar,
                avatarColor: '',
                avatarColorLetter: '',
                avatarLetter: ''
            }
        },
        { label: item.current_inventory_value, span: item.brand },
        { label: item.available, span: item.item_unit_name },
        { label: item.current_selling_price, span: item.last_sale_price }
    ];
}

//each element could organize their data diferent
export function organizeRow(data) {

    var newData = []

    if (data.length === 0) {
        newData.push({
            id: 'nothing', colum: [{ label: 'No Result', span: '' },
            { label: '', span: '' },
            { label: '', span: '' }]
        })
        return newData
    }

    data.forEach((elem) => {
        const timeSensitiveStyle = dtUpdate.getTimeSensitiveStyle(elem)
        const getTimeTemperatureStyle = dtUpdate.getTimeSensitiveStyle(elem)

        newData.push(
            {
                id: elem.id,
                trDetail: `data-item = '{"item_name":"${elem.name}", "item_unit_id":"${elem.item_unit_id}", "item_unit_name":"${elem.item_unit_name}"}'`,
                colum: getItemColumns(elem)
            }
        )/*push*/
    })/*forEach*/

    return newData
}/*organizeRow*/

//show dialog
export function dialogUpdateSellingPrice(detail) {

    let dbid = detail.dbid;
    let item_name = detail.item_name;
    let item_unit_id = detail.item_unit_id;
    let item_unit_name = detail.item_unit_name;
    dialogInventory.start({
        act: "show", dest: 'item', id: "dialogUpdateSellingPrice", entity: 'item', dbid: dbid,
        item_name: item_name, item_unit_id: item_unit_id, item_unit_name: item_unit_name
    });

}

//show dialog
export function confirmUpdateSellingPrice(detail) {
    let input_sellingPrice = document.querySelector('#inputUpdateSellingPrice');
    let input_value = (input_sellingPrice.value == "" || parseFloat(input_sellingPrice.value) == NaN ||
        parseFloat(input_sellingPrice.value) == 0) ? 0 : parseFloat(input_sellingPrice.value);

    if (input_value < 1) {
        inventorySnack.start({ act: 'show', id: 'invalidValue' });
        textfieldHandler.error(input_sellingPrice.closest(".textfield"));
        return;
    }

    dialog.start({ act: "hide" })

    setTimeout(() => {
        let dbid = detail.dbid;
        let item_unit_id = detail.item_unit_id;
        dialogInventory.start({
            act: "show", dest: 'item', id: "confirmUpdateSellingPrice", entity: 'item', dbid: dbid,
            item_unit_id: item_unit_id, newSellingPrice: input_value
        });
    }, 450);

}

// mostrar todos los item en el dt sin limit
export function showAllItem(htmlDt, detail) {
    htmlDt.footer.setAttribute('data-limit', 'complete');
    dtSearch.select(detail, htmlDt, true, () => resetDataLimit(htmlDt))
}

//colocar con 0 el limit del dt, este es un atributo que esta en el footer del html del dt en inventory-page
function resetDataLimit(htmlDt) {
    htmlDt.footer.setAttribute('data-limit', '0');
}
